var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 47,
    viewBox: "0 0 99 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1922 0H0V15.4078H49.9544C46.7332 10.4466 43.7072 5.37131 41.1922 0Z",
    fill: "url(#paint0_linear_3711_3194)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8496 25.6741C54.5318 22.2648 52.1975 18.8629 49.9526 15.4077H0V30.8155H60.2498C59.1328 29.0925 58.0067 27.375 56.8514 25.6741H56.8496Z",
    fill: "url(#paint1_linear_3711_3194)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2498 30.814H0V46.2218H69.9775C66.7288 41.0895 63.5513 35.9113 60.2498 30.814Z",
    fill: "url(#paint2_linear_3711_3194)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6367 0L87.1289 46.2216H92.7465C96.1996 46.2216 98.9992 43.4008 98.9992 39.9217L69.9986 0H53.6367Z",
    fill: "#01BAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9995 6.29994C98.9995 2.82081 96.1999 0 92.7468 0H79.0732L99.0014 27.5002V6.29994H98.9995Z",
    fill: "#01BAFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9072 0L62.122 46.2216H78.1353L44.5555 0H28.9072Z",
    fill: "#01BAFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3711_3194",
    x1: 0,
    y1: 7.70299,
    x2: 31.7456,
    y2: 7.70299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3711_3194",
    x1: 6.55936,
    y1: 23.1107,
    x2: 50.5585,
    y2: 23.1107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3711_3194",
    x1: 18.6743,
    y1: 38.5188,
    x2: 81.6416,
    y2: 38.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01BAFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a8a00f3263192f3cb1bd45acaa01e226.svg";
export { ForwardRef as ReactComponent };